import React, { useEffect, useState } from "react";
import MultiRangeSlider from "./MultirangeSlider";
import { useFormik } from "formik";
import { Form } from "react-bootstrap";
import { httpReauest } from "../../utils/httpRequest";
import { CDN_BASE_URL } from "../../config";
import { Link, useSearchParams } from "react-router-dom";

const Filter = ({ formik, dealerData, handleSubmit }) => {
  const [categories, setCategories] = useState();
  const [changed, setchanged] = useState(false);

  const {
    year_start,
    year_end,
    min_price,
    max_price,
    min_tonaj,
    max_tonaj,
    category,
    haveImg,
    onFire,
    search_key,
  } = formik.values;

  useEffect(() => {
    handleSubmit();
  }, [formik.values]);

  useEffect(() => {
    getData();
  }, []);

  async function getData(params) {
    await httpReauest("GET", "/category", {}, {}).then(({ data }) => {
      setCategories(data?.data);
    });
  }

  return (
    <div className="w-full flex flex-col gap-3 xl:gap-4 sticky top-[110px]">
      <h2 className="text-[16px]  xl:text-[20px] font-bold flex justify-between items-end ">
        دسته بندی ها
        {(year_start !== 1340 ||
          year_end !== 1403 ||
          min_price !== 0 ||
          max_price !== 20 ||
          min_tonaj !== 0 ||
          max_tonaj !== 10 ||
          category ||
          haveImg ||
          onFire ||
          search_key) && (
          <button
            onClick={() => {
              formik.resetForm();
              setchanged(!changed);
              formik.setFieldValue("year_start", 1340);
              formik.setFieldValue("year_end", 1403);
              formik.setFieldValue("min_price", 0);
              formik.setFieldValue("max_price", 20);
            }}
            className="text-red-500  text-[80%]"
          >
            حذف
          </button>
        )}
      </h2>
      <div className="grid grid-cols-2 gap-3">
        {categories?.map((cat) => (
          <span
            key={cat._id}
            onClick={() =>
              cat._id === formik.values.category
                ? formik.setFieldValue("category", "")
                : formik.setFieldValue("category", cat._id)
            }
            className={`${
              formik.values.category === cat._id ? "bg-black " : "border-brand"
            } py-2 xl:py-4 flex flex-col items-center justify-center  2xl:py-5 cursor-pointer rounded-[10px]`}
          >
            <img
              src={CDN_BASE_URL + cat.img}
              alt={cat.name}
              title={cat.name}
              className="w-[60%]"
              width={100}
              height={100}
            />
            <p
              className={`${
                formik.values.category === cat._id ? "text-secendory" : ""
              } text-[14px] xl:text-[16px] font-[500] text-center mt-2 mb-0`}
            >
              {cat.name}
            </p>
          </span>
        ))}
      </div>
      <div className="border-brand w-full p-4 flex flex-col gap-3 xl:gap-4">
        <span>
          <p className="text-[#2E3132] text-[14px] xl:text-[16px]  font-[500] mb-2 xl:mb-3">
            قیمت
          </p>
          <MultiRangeSlider
            min={0}
            max={20}
            type="price"
            changed={changed}
            text="year:"
            formik={formik}
            names={["min_price", "max_price"]}
            onChange={({ min, max }) => {
              formik.setFieldValue("min_price", min);
              formik.setFieldValue("max_price", max);
            }}
          />
        </span>
        <span>
          <p className="text-[#2E3132] text-[14px] xl:text-[16px] font-[500] my-1 xl:my-3">
            سال ساخت
          </p>
          <MultiRangeSlider
            min={1340}
            max={1403}
            type="year"
            changed={changed}
            text="year:"
            formik={formik}
            names={["year_start", "year_end"]}
            onChange={({ min, max }) => {
              formik.setFieldValue("year_start", min);
              formik.setFieldValue("year_end", max);
            }}
          />
        </span>
        <span className="pb-4">
          <p className="text-[#2E3132] text-[14px] xl:text-[16px] font-[500] my-1 xl:my-3">
            تناژ
          </p>
          <MultiRangeSlider
            min={0}
            max={10}
            type="tonaj"
            changed={changed}
            text="tonaj:"
            formik={formik}
            names={["min_tonaj", "max_tonaj"]}
            onChange={({ min, max }) => {
              formik.setFieldValue("min_tonaj", min);
              formik.setFieldValue("max_tonaj", max);
            }}
          />
        </span>
      </div>
      <Link to={"/faq"} className="btn-brand">
        سوالات متداول
      </Link>
    </div>
  );
};

export default Filter;
